const registerEN = {
	title: "Create your customer account",
	subtitle: "One account to book anywhere on Sin Fila.",
	sectionYou: "About you",
	sectionSecurity: "Security",
	confirmPassword: "Confirm password",
	phone: "Phone",
	rememberMe: "Remember me",
	email: "Email",
	password: "Password",
	firstName: "First name",
	lastName: "Last name",
	submit: "Register",
	loading: "Registering...",
	error: "We couldn't create your account. Please try again.",
	haveAccount: "Already have an account?",
	signIn: "Sign in",
	acceptTerms: "I agree to the",
	termsLink: "Terms & Conditions",
	mustAcceptTerms: "Please accept the Terms & Conditions to continue.",
	strength: {
		weak: "Weak password",
		fair: "Getting there",
		strong: "Strong password",
	},
	rules: {
		length: "8+ characters",
		upper: "Uppercase",
		lower: "Lowercase",
		number: "Number",
		symbol: "Symbol",
	},
	match: {
		ok: "Passwords match",
		bad: "Passwords don't match yet",
	},
};

export default registerEN;
